import axios from '@shared/axios-shared';

const getMaydayMessages = () => {
	return axios.get(`/api/v1/school/tickers/notifications`);
};

export { getMaydayMessages };
